import { useState, useEffect } from "react";
import { useHeaderContext } from "../../../context/headerContext";
import { useLocation } from "react-router-dom";
import { useUserContext } from "../../../context/userContext";
import Button from "../../../components/Button";
import BandCard from "../../../components/BandCard";
import fetchWithRefresh from "../../../utils/fetchWithRefresh";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { LogErrors } from "../../../utils/LogErrors";

export default function ParticipantBands() {
  const { setTitle, setBackButton } = useHeaderContext();
  const location = useLocation();
  const { participant } = location.state;
  const { user, logout, updateTokens } = useUserContext();
  const [bands, setBands] = useState([]);

  useEffect(() => {
    setTitle(`${participant.ParticipantName}'s Bands`);
    setBackButton(true);
    fetchBands();
  }, [participant]);

  const fetchBands = async () => {
    await Sentry.startSpan({ name: "Fetch Bands", op: "http.request" }, async (span) => {
      try {
        const url = `${import.meta.env.VITE_API_URL}Bands/FetchBands?participantid=${participant.ParticipantId}`;
        span.setAttribute("http.url", url);
  
        const response = await fetchWithRefresh(url, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.token}`,
          },
        }, logout, updateTokens, (message) => { toast.info(message); });
  
        span.setAttribute("http.status_code", response.status);
  
        if (response.ok) {
          const data = await response.json();
          setBands(data);
        } else {
          Sentry.captureMessage("Error fetching bands", { extra: { status: response.status, url } });
          LogErrors(user, logout, updateTokens, 'Error fetching bands');
        }
      } catch (error) {
        Sentry.captureException(error);
        LogErrors(user, logout, updateTokens, error);
        span.setStatus("error");
      } finally {
        span.end();
      }
    });
  };

  return (
    <div className="flex flex-col gap-5">
      {!bands.length === 0 ? (
        <>
          <h3 className="mb-2">Activate New Bands</h3>
          <BandCard /> 
        </>
        ) : (
        bands.map((band, index) => {
          return (
            <BandCard
              href={"/participant/" + participant.ParticipantId + "/bands/" + band.BandID}
              band={band}
              participant={participant}
              key={index}
              type={'band'}
            />
          );
        })
      )}
      <div className="mt-4">
        <Button variant="primary" href={'/shop/my-participants'} className="w-full">
          Order New Band
        </Button>
      </div>
    </div>
  );
}
